import { IconProps } from "./IconProps";

const Lightning: React.FC<IconProps> = ({
  width = 44,
  height = 44,
  color = "#FCFCFD",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 44 44" fill="none">
      <g clipPath="url(#clip0_32_99)">
        <path
          d="M8.19371 24.2497L24.874 1.15389C25.9773 -0.373799 28.3876 0.631974 28.0778 2.49079L25.763 16.3795H34.7559C36.2102 16.3795 37.0527 18.0271 36.2012 19.2061L19.5209 42.3019C18.4175 43.8296 16.0073 42.8238 16.3171 40.965L18.6318 27.0763H9.63899C8.18464 27.0763 7.3422 25.4287 8.19371 24.2497Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_32_99">
          <rect
            width="42.7871"
            height="42.7871"
            fill="white"
            transform="translate(0.803833 0.334473)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Lightning;
